import axios from 'axios';
import { infoStore, ParticipationStatus } from '../store/infoStore';
import { useCallback } from 'react';
import { createBaseParams, getApiEndPoint } from '../utils';
import { qrStore } from '../store/qrStore';
import { modalStore } from '../store/modalStore';
import { useDateHook } from './useDateHook';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const eventBase = `${getApiEndPoint()}/api-gateway`;
const API_URL = {
  eventInfo: `${eventBase}/nhapi/tnmt/event`,
  qrHash: `${eventBase}/nhapi/tnmt/event/hash`,
  getTicket: `${eventBase}/neapi/tnmt/event/ticket`,
  agreePrivacy: `${eventBase}/nhapi/tnmt/event/agree`,
};

export const ENTRY_GROUP = {
  MAIN: 1,
  SIDE: 2,
};

export const useApiHook = () => {
  const { setMainInfo, setSideInfo } = infoStore();
  const { setMainQrData, setSideQrData } = qrStore();
  const { showIsVisibleEndDate, showPrivacyModal } = modalStore();
  const { isOverPrivacyDate } = useDateHook();

  const getEventInfo = useCallback(
    (entryGroupSrl = ENTRY_GROUP.MAIN) => {
      const setInfo = entryGroupSrl === ENTRY_GROUP.MAIN ? setMainInfo : setSideInfo;

      axios
        .post(API_URL.eventInfo, createBaseParams(entryGroupSrl))
        .then((response) => {
          setInfo(response.data.data);
          return response.data.data;
        })
        .then((r) => {
          const userStatus = r.status;
          if (userStatus === ParticipationStatus.NOT_AGREED) {
            // 동의 기간이 지난 경우
            if (!isOverPrivacyDate) {
              showPrivacyModal();
              return;
            }
            showIsVisibleEndDate();

            return;
          }
        })
        .catch((e) => {
          console.log(e);
          setInfo({
            status: 3,
            ticketCnt: 0,
            ticketNo: 0,
          });
        });
    },
    [setMainInfo, setSideInfo, showIsVisibleEndDate, showPrivacyModal, isOverPrivacyDate]
  );

  const getQr = useCallback(
    (entryGroupSrl = ENTRY_GROUP.MAIN) => {
      const isMainEvent = entryGroupSrl === ENTRY_GROUP.MAIN;
      const setter = isMainEvent ? setMainQrData : setSideQrData;

      axios
        .post(API_URL.qrHash, createBaseParams(entryGroupSrl))
        .then((response) => setter(response.data.data))
        .catch((e) => {
          alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
          console.log(e);
          setter({
            qrHash: '',
            createDate: '',
          });
        });
    },
    [setMainQrData, setSideQrData]
  );

  const getMainQr = useCallback(() => {
    return getQr(ENTRY_GROUP.MAIN);
  }, [getQr]);

  const getSideQr = useCallback(() => {
    return getQr(ENTRY_GROUP.SIDE);
  }, [getQr]);

  const postAgreePrivacy = (callback: () => void) => {
    return axios
      .post(API_URL.agreePrivacy, createBaseParams())
      .then(callback)
      .then(() => {
        getEventInfo(ENTRY_GROUP.MAIN);
        getEventInfo(ENTRY_GROUP.SIDE);
      });
  };

  return {
    getEventInfo,
    getQr,
    getMainQr,
    getSideQr,
    postAgreePrivacy,
  };
};
